// extracted by mini-css-extract-plugin
export default {"arrow":"arrow-U8Wa3","container":"container-ddC95"};